module.exports = __webpack_public_path__ + "img/press-5.63cb25e8.jpg";